import Cookies from 'universal-cookie';
import { CLEAR_INFORMATIONS } from '../../utils/utils';

const deconnecterUtilisateur = () => (dispatch) => {
    const cookie = new Cookies();
    dispatch({ type: CLEAR_INFORMATIONS });

    cookie.remove('KEYCLOAK_SESSION');
    window.localStorage.removeItem('persist:root');
    window.location.href = process.env.REACT_APP_KEYCLOAK_LOGOUT_URI;
};

export default deconnecterUtilisateur;
